import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';

class UtilizationAlert extends Component {
  render() {
    return (
      <AlertItem
        alert={this.props.alert}
        onIsFlaggedChange={this.props.onIsFlaggedChange}
        date={moment(this.props.alert.date).format('MMMM YYYY')}
        icon='desktop'
        title={(
          <div>
            <Link to={`/corporate/analyze/buyer/${this.props.alert.buyer.id}`}>
              {this.props.alert.buyer.name}
            </Link>
            {' utilized Vetcove for '}
            <strong className='u-colorRed'>
              {this.props.alert.value.percent.toFixed(1)}%
            </strong>
            {' '} of ordered items during {moment(this.props.alert.date).format('MMMM')}
          </div>
        )}
        {...this.props}
      />
    );
  }
}

UtilizationAlert.propsTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default UtilizationAlert;
